import './EditorTipTap.scss';
//todo: check if we can have same styling for basic and full editor
// Types
import mixins from "vue-typed-mixins"; // Mixins
import sectionView from '../../mixins/sectionView';
import EditorBase from '../../mixins/EditorBase';
import { WithRefs } from '../../utils/withRefs';
import ControllerBase from '../../mixins/ControllerBase';

// Components
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble, Mark
// @ts-ignore
} from 'tiptap';
import { Blockquote, Bold, BulletList, Code, CodeBlock, HardBreak, Heading, History, HorizontalRule, Image, Italic, Link, ListItem, OrderedList, Placeholder, Strike, TodoItem, TodoList, Underline
// @ts-ignore
} from 'tiptap-extensions';
// @ts-ignore
import { markInputRule, updateMark } from 'tiptap-commands';
import { preventDefault, valueFromInput } from '../../utils/jsxHelpers';
import { WithPartialInject } from '../../utils/withInject';
import TicketInjector from '../../mixins/TicketInjector';
import { TicketProviders } from '../../enums/TicketProvider';
const dummyInject = WithPartialInject('dummyMode');
class Align extends Mark {
  get name() {
    return 'align';
  }
  get defaultOptions() {
    return {
      levels: ['left', 'center', 'right', 'justify']
    };
  }
  get schema() {
    return {
      attrs: {
        align: {
          default: 'left'
        }
      },
      parseDOM: [{
        style: 'text-align',
        getAttrs: value => ({
          align: value
        })
      }],
      toDOM: mark => {
        return ['span', {
          class: `block text-${mark.attrs.align}`
        }, 0];
      }
    };
  }
  commands({
    type
  }) {
    return attrs => updateMark(type, attrs);
  }
  inputRules({
    type
  }) {
    return [markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type)];
  }
}
const CmsTipTapEditor = mixins(ControllerBase, sectionView, EditorBase(() => ''), WithRefs(), dummyInject, TicketInjector(TicketProviders.ImageMarkers)).extend({
  name: 'EditorTipTap',
  components: {
    EditorContent,
    EditorMenuBubble,
    EditorMenuBar
  },
  props: {
    full: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    // Toolbar options
    showToolbar: {
      type: Boolean,
      default: true
    },
    showList: {
      type: Boolean,
      default: true
    },
    contentClass: {
      type: String,
      default: ''
    },
    hideBoxStyling: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editor: null,
      linkUrl: '',
      linkMenuIsActive: false
    };
  },
  watch: {
    // Changing language changes content in layout elements,
    // so if editor is open when that happens, we need to refresh
    // its content (shit's not reactive)
    'componentData.language_code'() {
      var _this$editor;
      (_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.setContent(this.computedValue);
    },
    value(v) {
      var _this$editor2, _this$editor3;
      v !== ((_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.getHTML()) && ((_this$editor3 = this.editor) === null || _this$editor3 === void 0 ? void 0 : _this$editor3.setContent(v || ''));
    }
  },
  mounted() {
    this.editor = new Editor({
      extensions: [new Align(), new Blockquote(), new BulletList(), new CodeBlock(), new HardBreak(), new Heading({
        levels: [1, 2, 3, 4, 5, 6]
      }), new HorizontalRule(), new ListItem(), new OrderedList(), new TodoItem(), new TodoList(), new Link({
        openOnClick: false
      }), new Bold(), new Code(), new Italic(), new Strike(), new Underline(), new History(), new Image(), new Placeholder({
        emptyEditorClass: 'is-editor-empty',
        emptyNodeClass: 'is-empty',
        emptyNodeText: this.$at('core.input.enterText'),
        showOnlyWhenEditable: true,
        showOnlyCurrent: true
      })],
      content: this.computedValue,
      onUpdate: ({
        getHTML
      }) => {
        const newValue = getHTML().replace(/<p([^>]*style="(\S*)"[^>]*)*><\/p>/gi, '<p$1><br/></p>').replace(/<\/*pre>/g, '').replace(/<\/*code>/g, '').replace(/^<p><\/*br\/*><\/p>$/g, '<p></p>');
        this.computedValue = newValue;
      },
      onInit: e => {
        if (!this.contentClass) return;
        const classes = this.contentClass.split(' ').filter(Boolean);
        if (!classes.length) return;
        e.view.dom.classList.add(...classes);
      }
    });
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
    }
  },
  methods: {
    focus() {
      var _this$editor4;
      (_this$editor4 = this.editor) === null || _this$editor4 === void 0 ? void 0 : _this$editor4.focus();
    },
    clearContent() {
      var _this$editor5, _this$editor6;
      (_this$editor5 = this.editor) === null || _this$editor5 === void 0 ? void 0 : _this$editor5.clearContent(true);
      (_this$editor6 = this.editor) === null || _this$editor6 === void 0 ? void 0 : _this$editor6.focus();
    },
    showLinkMenu(attrs) {
      this.linkUrl = attrs.href;
      this.linkMenuIsActive = true;
      this.$nextTick(() => {
        var _this$$refs$linkInput;
        (_this$$refs$linkInput = this.$refs.linkInput) === null || _this$$refs$linkInput === void 0 ? void 0 : _this$$refs$linkInput.focus();
      });
    },
    hideLinkMenu() {
      this.linkUrl = '';
      this.linkMenuIsActive = false;
    },
    setLinkUrl(command, clear = false) {
      if (clear) {
        this.linkUrl = '';
        command({
          href: ''
        });
      } else {
        console.log(this.linkUrl);
        command({
          href: this.linkUrl,
          target: '_blank'
        });
      }
      this.hideLinkMenu();
    },
    showImagePrompt(command) {
      const src = prompt('Enter the url of your image here');
      if (src !== null) {
        command({
          src
        });
      }
    },
    getEditorContent(props) {
      var _props$menu, _props$menu2, _props$menu3;
      const h = this.$createElement;
      const test = (_props$menu = props.menu) !== null && _props$menu !== void 0 && _props$menu.isActive ? ' is-active' : '';
      const name = this.full ? 'menubar' : 'menububble';
      return h("div", {
        "class": [name, test],
        "style": {
          left: `${(_props$menu2 = props.menu) === null || _props$menu2 === void 0 ? void 0 : _props$menu2.left}px`,
          bottom: `${(_props$menu3 = props.menu) === null || _props$menu3 === void 0 ? void 0 : _props$menu3.bottom}px`
        }
      }, [h("button", {
        "class": `${name}__button` + (props.isActive.bold() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.bold()
        }
      }, [h("em", {
        "class": "core-icon-bold"
      })]), h("button", {
        "class": `${name}__button` + (props.isActive.italic() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.italic()
        }
      }, [h("em", {
        "class": "core-icon-italic"
      })]), h("button", {
        "class": `${name}__button` + (props.isActive.strike() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.strike()
        }
      }, [h("em", {
        "class": "core-icon-strikethrough"
      })]), h("button", {
        "class": `${name}__button` + (props.isActive.underline() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.underline()
        }
      }, [h("em", {
        "class": "core-icon-underline"
      })]), h("button", {
        "class": `${name}__button` + (props.isActive.code() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.code()
        }
      }, [h("em", {
        "class": "core-icon-code"
      })]), h("button", {
        "class": `${name}__button`,
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => this.showImagePrompt(props.commands.image())
        }
      }, [h("em", {
        "class": "core-icon-image"
      })]), h("button", {
        "class": `${name}__button` + (props.isActive.paragraph() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.paragraph()
        }
      }, [h("em", {
        "class": "core-icon-paragraph"
      })]), this.full || this.showList ? h("button", {
        "class": `${name}__button` + (props.isActive.bullet_list() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.bullet_list()
        }
      }, [h("em", {
        "class": "core-icon-list-ul"
      })]) : undefined, this.full || this.showList ? h("button", {
        "class": `${name}__button` + (props.isActive.ordered_list() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.ordered_list()
        }
      }, [h("em", {
        "class": "core-icon-list-ol"
      })]) : undefined, h("button", {
        "class": `${name}__button` + (props.isActive.blockquote() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.blockquote()
        }
      }, [h("em", {
        "class": "core-icon-quote-right"
      })]), h("button", {
        "class": `${name}__button`,
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.undo()
        }
      }, [h("em", {
        "class": "core-icon-undo"
      })]), h("button", {
        "class": `${name}__button`,
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.redo()
        }
      }, [h("em", {
        "class": "core-icon-redo"
      })]), h("button", {
        "class": `${name}__button` + (props.isActive.link() ? ' text-blue-600 is-active' : ''),
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => this.showLinkMenu(props.getMarkAttrs('link'))
        }
      }, [h("em", {
        "class": props.isActive.link() ? 'core-icon-unlink' : 'core-icon-link'
      })]), [1, 2, 3, 4, 5, 6].map(n => h("button", {
        "class": `${name}__button` + (props.isActive.heading({
          level: n
        }) ? ' text-blue-600 is-active' : ''),
        "style": 'font-size: 12px',
        "attrs": {
          "type": "button"
        },
        "on": {
          "click": () => props.commands.heading({
            level: n
          })
        }
      }, ["H", n])), this.linkMenuIsActive ? h("form", {
        "class": `${name}__form`,
        "on": {
          "submit": preventDefault(() => this.setLinkUrl(props.commands.link))
        }
      }, [h("input", {
        "domProps": {
          "value": this.linkUrl
        },
        "on": {
          "input": valueFromInput(v => this.linkUrl = v)
        },
        "class": `${name}__input`,
        "ref": 'linkInput',
        "attrs": {
          "type": 'text',
          "placeholder": 'https://'
        }
      }), h("button", {
        "class": `${name}__input mx-2`,
        "attrs": {
          "type": 'submit'
        }
      }, [h("em", {
        "class": "core-icon-check"
      })]), h("button", {
        "class": `${name}__input`,
        "attrs": {
          "type": 'button'
        },
        "on": {
          "click": () => this.setLinkUrl(props.commands.link, true)
        }
      }, [h("em", {
        "class": "core-icon-times"
      })])]) : undefined]);
    },
    createEditorContent() {
      const dot = !!this[TicketProviders.ImageMarkers] ? 'in-dot' : '';
      return this.contentEditableView ? this.$createElement('editor-content', {
        ref: 'content',
        class: this.hideBoxStyling ? dot : 'editor__content ' + dot,
        props: {
          editor: this.editor
        }
      }) : this.$createElement(this.inline ? 'span' : 'div', {
        class: this.contentClass,
        domProps: {
          innerHTML: this.dummyMode ? 'Dummy Tip Tap Editor' : this.computedValue
        }
      });
    },
    createEditorMenuBubble() {
      if (this.full && this.contentEditableView) return this.$createElement('editor-menu-bar', {
        props: {
          editor: this.editor,
          keepInBounds: true
        },
        on: {
          hide: this.hideLinkMenu
        },
        scopedSlots: {
          default: props => [this.getEditorContent(props)]
        }
      });
      if (!this.full && this.showToolbar && this.contentEditableView) return this.$createElement('editor-menu-bubble', {
        class: 'showToolbar',
        props: {
          editor: this.editor,
          keepInBounds: true
        },
        on: {
          hide: this.hideLinkMenu
        },
        scopedSlots: {
          default: props => [this.getEditorContent(props)]
        }
      });
    }
  },
  render(h) {
    return h('div', {
      class: this.contentEditableView ? 'editor editable-text' : 'custom_tiptap editable-text'
    }, [this.createEditorMenuBubble(), this.createEditorContent()]);
  }
});
export default CmsTipTapEditor;